import React, { Component } from 'react';
import { json, Link, Navigate } from "react-router-dom";
import API from "../../config/api";
import moment from 'moment';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';
import './../custom.css';

export class GroupPermissionEdit extends Component {

    constructor(props) {
        super(props)
      
        this.state = {
          page: 1,
          folder_id: null,
          name: '',
          description: '',
          code: '',
          thumbnail: null,
          full_thumbnail: null,


          levels : [{name: 'Level 1', id : 1}, {name: 'Level 2', id : 2}, {name: 'Level 3', id : 3}],
          selectedOptions: [],
          all_folders: [],
          s: '',
          total: null,
          limit: 100,

          fields: {
            name: "",
            // description: ""
          },
          errors: {},

          id: 1,
          quizs: [],
          all_categories: [],
          selected_categories: [],
          added_questions: [],

          data: [],
          percentage: 0,
          disable: true,
          // thumbnail: null,
          // image_url: "",
          // description: "",
          success: null,
          category_id: 1,
          categories: [],
        };
        this.inputRefs = {
          name: React.createRef(),
          // description: React.createRef(),
        };
      }

      UNSAFE_componentWillMount() {
        this.getParam("id")
        this.getAllFolder();
        this.getImage();
      }

      getParam(name) {
        let id = window.location.search.split(`${name}=`)[1]
        this.state.id = id;
        this.setState({})
        if (id) {
          this.getOnePermission();
        }
        // this.setState({category_id : id})
        
        // return 
      }

      getImage() {
        let url = API.getImage();
        this.setState({image_url : url})
      }

      // getOneQuestion = async (id) => {
      //   try {
      //     let query = `id=${id}`
      //     let results = await API.getOneQuestion(query);
    
      //     let data = results.data.quiz;
      //     this.state.added_questions.push(data)
      //     this.setState({})
      //   } catch (error) {
      //     console.log(error)
      //   }
      // }
    
      getOnePermission = async () => {
        try {
          let query = `id=${this.state.id}`
          let results = await API.getOnePermission(query);
    
          let data = results.data;

          // let all_quiz = data.quiz.quiz;
          // all_quiz.map(quiz => {
          //   this.getOneQuestion(quiz.id);
          // })
          let all_levels = data.level.map(level => {
            return level
          })

          // this.setState({ 
          //   added_questions: data.folder,
          //   selectedOptions: all_levels,
          //   data : data, 
          //   description: data.description,
          //   name: data.name,
          // });
          this.state.added_questions = data.folder;
          this.state.selectedOptions = all_levels;
          this.state.data = data;
          this.state.description = data.description;
          this.state.name = data.name;
          this.state.fields.name = data.name;
          this.setState({})
    
        } catch (error) {
          console.log(error)
        }
      }

      

      getAllFolder = async () => {
        try {
          let query = `page=${this.state.page}&s=${this.state.s}&limit=${this.state.limit}`
          let results = await API.getAllFolder(query);
          let data = results.data;
          
          this.setState({ all_folders : data.folder, total: data.total });
    
        } catch (error) {
          console.log(error)
        }
      }

      onSearch = async (event) => {
        event.preventDefault();
        let value = event.target.value;
        this.state.s = value;
        this.getAllFolder();
      }

      getAllCategories = async () => {
        try {
          let query = `page=${this.state.page}`
          let results = await API.getAllCategory(query);
          let data = results.data;

          let tags = data.category.map(tag => {
            return {
              value: tag,
              label: tag.name,
              id: tag.id
            }
          });
          tags.unshift({
            value: null,
            label: "All",
            id: 0
          })
          this.setState({ all_categories : tags });
    
        } catch (error) {
          console.log(error)
        }
      }

      getOneCategory = async (category_id) => {
        try {
          let query = "";

          if (category_id) {
            query = `category_id=${category_id}`
          }
          let results = await API.getAllQuestions(query);
    
          let data = results.data.result;

          this.setState({quizs: data.quiz });
    
        } catch (error) {
          console.log(error)
        }
      }

      onUploadProgress = (percentage) => {
        this.setState({ percentage: percentage})
        if (percentage ===100) {
          this.setState({ disable: false })
        }
      }

      onChangeFile = async (event) => {
        event.preventDefault();
        let file = event.target.files[0];
        let name = event.target.name;
        const formData = new FormData();
        formData.append("file", file);
        
        try {
          let results = await API.adminUpload(
            formData,
            this.onUploadProgress
          );
          
          if (results){
            this.state.thumbnail = results.filename;
            this.state.full_thumbnail = results.full_url;
            // this.setState({ data: {
            //   ...this.state.data,
            //   [name]: results.filename,
            // }})
          }
    
        } catch (error) {
          console.log(error)
        }
      }

      validateFields = () => {
        const { fields } = this.state;
        const errors = {};
        let firstEmptyField = null;
    
        // Check for empty fields
        Object.keys(fields).forEach((field) => {
          if (!fields[field].trim()) {
            errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            if (!firstEmptyField) {
              firstEmptyField = field; // Record the first empty field
            }
          }
        });
    
        this.setState({ errors });
    
        // Focus on the first empty field
        if (firstEmptyField) {
          this.inputRefs[firstEmptyField].current.focus();
        }
    
        // Return true if no errors
        return Object.keys(errors).length === 0;
      };

      handelInput = (event) => {

        const { name, value } = event.target;
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            [name]: value,
          },
          errors: {
            ...prevState.errors,
            [name]: "", 
          },
        }));
      }
      
      onRemoveQuestion(data){
        this.state.added_questions.splice(this.state.added_questions.indexOf(data), 1);
        this.state.quizs.push(data)
        // toast.success("Your action is successful", {
        //   data: {
        //     title: "Success toast",
        //     text: "This is a success message",
        //   },
        // })
        this.setState({})
    
      }

      onAddQuestion(data  = {}) {
        data.new = true;
        this.state.added_questions.unshift(data);
        
        // this.state.added_questions.push(data)
        // this.state.quizs.splice(this.state.quizs.indexOf(data), 1)

        // toast.success("Your action is successful", {
        //   data: {
        //     title: "Success toast",
        //     text: "This is a success message",
        //   },
        // })
        this.setState({})
      }

      handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        const intValue = parseInt(value, 10);
        this.setState((prevState) => {
          if (checked) {
            return {
              selectedOptions: [...prevState.selectedOptions, intValue],
            };
          } else {
            return {
              selectedOptions: prevState.selectedOptions.filter(
                (option) => option !== intValue
              ),
            };
          }
        });
      };
    
      handleSubmit = async (event) => {
        event.preventDefault();
        if (!this.validateFields()) return
        let quiz_id = this.state.added_questions.map(quiz => {
          return quiz.id
        });

        if (this.state.selectedOptions.length == 0) {
          toast.error("Level can not be empty, please add at least one level", {
             data: {
               title: "Error toast",
               text: "This is a error message",
             },
           })
           return ;
       }

       if (this.state.added_questions.length == 0) {
        toast.error("Folder can not be empty, please add at least one folder", {
           data: {
             title: "Error toast",
             text: "This is a error message",
           },
         })
         return ;
     }

         let data = {
          id: this.state.id,
          name: this.state.name,
          description: this.state.description,
          // code: this.state.code,
          // thumbnail: this.state.thumbnail,
          // level: JSON.stringify([1,2]), 
          level: JSON.stringify(this.state.selectedOptions), 
          folder_id: JSON.stringify(quiz_id)
         }

        // this.state.data.quiz_id = JSON.stringify(quiz_id)
        
        try {
          let results = await API.postOnePermission(data);
          if (results.result === 1){
            
            this.setState({ success: results.result })
          }
    
        } catch (error) {
          console.log(error)
        }
      }

  render() {
    const { levels, selectedOptions, fields, errors } = this.state;
    return (
        <div className="col-12">
          <ToastContainer />
          {this.state.success && (
              <Navigate to="/grouppermissionindex?success=true" replace={true} />
          )}
            <form className="card" onSubmit={this.handleSubmit} >
                <h4 className="card-title"><strong>Group Permission</strong></h4>

                <div className="card-body row">

                    <div className="col-md-6">
                    <div className="form-group">
                        <label className="require" for="input-required">Name</label>
                        <input type="text" className="form-control" id="input-required" 
                          ref={this.inputRefs.name}
                          value={this.state.name} name='name' 
                          style={{
                            border: errors.name ? "1px solid red" : "", // Apply red border on error
                          }}
                          onChange={(event) => {
                            this.state.name = event.target.value;
                            this.setState({})
                            this.handelInput(event)
                          }} />
                          {errors.name && <span style={{ color: "red" }}>{errors.name}</span>}

                        {/* <input type="text" className="form-control" id="input-required" 
                          value={this.state.name} name='name' 
                          onChange={(event) => {
                            this.state.name = event.target.value;
                            this.setState({})
                          }} /> */}
                    </div>
                    {/* <div className="form-group">  
                        <label for="inputState" className="col-form-label">Parent</label>
                        <select id="inputState" className="form-control">
                        <option>Short Film</option>
                        <option>Funny</option>
                        <option>Love story</option>
                        <option>Sad story</option>
                        </select>
                    </div> */}
                    
                    </div>


                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Description</label>
                        <input className="form-control" type="text" value={this.state.description} name='description'
                        // ref={this.inputRefs.description}
                        style={{
                          border: errors.description ? "2px solid red" : "", 
                        }}
                        onChange={(event) => {
                          this.state.description = event.target.value;
                          this.setState({})
                          // this.handelInput(event)
                        }} />
                        {/* {errors.description && <span style={{ color: "red" }}>{errors.description}</span>} */}
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                      <div className="form-group">
                        <label>Code</label>
                        <input className="form-control" type="text" value={this.state.code} name='code' onChange={(event) => {
                          this.state.code = event.target.value;
                          this.setState({})
                        }} />
                      </div>
                    </div> */}
                    {/* <div className='col-md-6'></div>  */}
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="require" for="input-required">Level </label> <br />
                          <div className=''> 
                          {levels.map((level) => (
                            <div style={{alignItems: "center", paddingLeft: 19}} className='row ' key={level}>
                              <input
                                  checked={selectedOptions.includes(level.id)}
                                  type="checkbox"
                                  value={level.id}
                                  onChange={this.handleCheckboxChange}
                                  style={{marginRight:10, marginTop: 9}}  className='form-group'
                                  />
                              <h4>{level.name}</h4> 
                            </div>
                          ))}
                          </div>
                        </div>  
                      </div> 
                    
                </div>



                {/* add class */}
                
                

                <h4 className="card-title"><strong>All Folders</strong></h4>
                <div className="card-body row">

                  <div className="col-md-6">
                    <div className="card-body">

                  <div className="flexbox mb-20">
                      <div className="lookup">
                        <input className="w-200px" type="text" name="s" placeholder="Search" onChange={this.onSearch} />
                      </div>

                      <div className="btn-toolbar">
                        <div className="btn-group btn-group-sm">
                        {/* <Select
                          required
                          styles={{
                            menu: provided => ({ ...provided, zIndex: 9999 }),
                            control: (base, state) => ({
                              ...base,
                              '&:hover': { borderColor: '#4ed2c5' },
                              '&:focus': {
                                borderColor: '1px solid #4ed2c5',
                                boxShadow: '0px 0px 6px #4ed2c5',
                              },
                              border: '1px solid #4ed2c5',
                              borderColor: state.isFocused ? '#4ed2c5' : '#ebebeb',
                              boxShadow: 'none',
                              width:'200px',
                          }),
                          }}
                          defaultValue={{
                            value: 0,
                            label: 'All',
                            id: 0
                          }}
                          isMulti={this.state.isMulti}

                          name="options"
                          options={this.state.all_categories}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          
                          onChange={value => {
                            this.getOneCategory(value.id);
                            this.setState({selected_tag: value})
                            
                          }}
                        /> */}

                          {/* <button className="btn" title="Refresh" data-provide="tooltip"><i class="ion-refresh"></i>  </button> */}
                          {/* <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i></button> */}
                          {/* <Link to="/categorynew" > <button className="btn btn-primary" title="Add new" data-provide="tooltip"> <i className="ion-plus-round"></i></button></Link> */}
                          {/* <Link to="/user/new" > <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i>New</button></Link> */}
                        </div>

                        {/* <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">
                          <button className="btn dropdown-toggle" data-toggle="dropdown">Type</button>
                          <div className="dropdown-menu dropdown-menu-right">
                            
                            <a className="dropdown-item" href="/">All</a>
                            <a className="dropdown-item" href="/">Reading</a>
                            <a className="dropdown-item" href="/">Listioning</a>
                          </div>
                        </div> */}
                        </div>
                      </div>
                    <div>
                   </div>
                </div>

                <div className="table-container" >
                    <table className="fixed-header-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            {/* <th>Thumbnail</th> */}
                            <th>Name</th>
                            <th>Code</th>
                            {/* <th>Release Date</th> */}
                            <th className="text-center w-150px">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                        {
                          this.state.all_folders && this.state.all_folders.map((quiz, index)=> {
                            // quiz style

                            let add_id = this.state.added_questions.map(q => q.id);

                            let style = {};

                            let added = false;

                            if (add_id.includes(quiz.id)) {
                              style = {background: '#d9d9d9'};
                              added = true;
                            }

                            return <tr style={style}>
                              <th scope="row">{( (this.state.page - 1) * 10) + (index+ 1)} </th>
                              {/* <td>
                                <div class="media">
                                  <img class="avatar" src={quiz.full_image_url ? quiz.full_image_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." />
                                  <div class="media-body">
                                  </div>
                                </div>
                              </td> */}
                              <td>{quiz.name}</td>
                              <td>{quiz.code}</td>
                              {/* <td className="w-100px">{quiz.code}</td> */}
                              
                              {/* <td>{moment(quiz.created_at).format("DD-MMM-YYYY")}</td> */}
                              <td className="text-center table-actions">
                                <button className="btn btn-square  btn-primary" disabled={added} onClick={() => this.onAddQuestion(quiz)}><i className="fa fa-plus" ></i></button>
                                {/* <span>&nbsp;</span><Link className="btn btn-square btn-round btn-info" title="Edit" to={`/questionedit?id=${quiz.id}`}><i className="ti-pencil"></i></Link>
                              
                                <span>&nbsp;</span><Link title="Delete" onClick={() => this.setState({data: quiz})} className="btn btn-square btn-round btn-danger"><i className='ti-trash' data-toggle="modal" data-target="#modal-center" ></i> </Link> */}
                              </td>
                            </tr>
                            
                          })
                        }
                        </tbody>
                      </table>
                     </div>
                    </div>

                    <div className="col-md-6">
                      <div className="card-body">

                  <div className="flexbox mb-20">
                      {/* <div className="lookup">
                        <input className="w-200px" type="text" name="s" placeholder="Search" onChange={this.onSearch} />
                      </div> */}
                      <h5>Total folders added:  <b className="text-success fw-500 w-80px">{this.state.added_questions.length}</b>&nbsp;<i class="fa fa-folder-open"> </i></h5>

                      <div className="btn-toolbar">
                        <div className="btn-group btn-group-sm">
                          {/* <button className="btn" title="Refresh" data-provide="tooltip"><i class="ion-refresh"></i>  </button> */}
                          {/* <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i></button> */}
                          {/* <Link to="/categorynew" > <button className="btn btn-primary" title="Add new" data-provide="tooltip"> <i className="ion-plus-round"></i></button></Link> */}
                          {/* <Link to="/user/new" > <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i>New</button></Link> */}
                        </div>

                        <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">
                          {/* <button className="btn dropdown-toggle" data-toggle="dropdown">Type</button> */}
                          <div className="dropdown-menu dropdown-menu-right">
                            
                            <a className="dropdown-item" href="/">All</a>
                            {/* {this.state.all_categories && this.state.all_categories.map((category, index) => {
                              return <a className="dropdown-item" href="/">idaiii</a>
                              
                            })} */}
                            <a className="dropdown-item" href="/">Reading</a>
                            <a className="dropdown-item" href="/">Listioning</a>
                          </div>
                        </div>
                        </div>
                      </div>
                    <div>
                   </div>
                </div>
                <div style={{paddingBottom: '4px'}}></div>

                <div className="table-container" >         
                  <table className="fixed-header-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            {/* <th>Thumbnail</th> */}
                            <th>Name</th>
                            <th>Code</th>
                            {/* <th>Release Date</th> */}
                            <th className="text-center w-150px">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                        {
                          this.state.added_questions && this.state.added_questions.map((quiz, index)=> {
                            return <tr style={{backgroundColor: quiz.new ? '#4ADA59' : ''}}>
                              <th scope="row">{( (this.state.page - 1) * 10) + (index+ 1)}</th>
                              {/* <td>
                                <div class="media">
                                  <img class="avatar" src={quiz.full_image_url ? quiz.full_image_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." />
                                  <div class="media-body">
                                  </div>
                                </div>
                              </td> */}
                              <td>{quiz.name}</td>
                              <td>{quiz.code}</td>
                              {/* <td className="w-100px">{quiz.code}</td> */}
                              {/* <td>{moment(quiz.created_at).format("DD-MMM-YYYY")}</td> */}
                              <td className="text-center table-actions">
                                <Link className="btn btn-square btn-round btn-danger" title="View" onClick={() => this.onRemoveQuestion(quiz)}><i className="fa fa-minus"></i></Link>
                                
                              </td>
                            </tr>
                            
                          })
                        }
                        </tbody>
                      </table>
                     </div>
                    </div>

                </div>    


                <footer className="card-footer text-right">
                    <Link className="btn btn-secondary" to="/grouppermissionindex">Cancel</Link>
                    <button className="btn btn-primary" type="submit">Submit</button>
                </footer>
            </form>
        </div>
    )
  }
}

export default GroupPermissionEdit